import { libConfig } from '../config';
export var validators = {
    isHidden: function (element) { return element.getAttribute(libConfig.tag) === libConfig.values.hidden; },
    isVisible: function (element) { return element.getAttribute(libConfig.tag) === libConfig.values.visible; },
    hasTagDefined: function (element) { return !!element.getAttribute(libConfig.tag); },
};
//# sourceMappingURL=validator.js.map